import React from 'react';

const Laundromat = (props: object) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      {...props}
    >
      <path
        d="M24.375 4.6875H5.625C5.10723 4.6875 4.6875 5.10723 4.6875 5.625V24.375C4.6875 24.8928 5.10723 25.3125 5.625 25.3125H24.375C24.8928 25.3125 25.3125 24.8928 25.3125 24.375V5.625C25.3125 5.10723 24.8928 4.6875 24.375 4.6875Z"
        stroke="CurrentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 21.5625C18.6244 21.5625 21.5625 18.6244 21.5625 15C21.5625 11.3756 18.6244 8.4375 15 8.4375C11.3756 8.4375 8.4375 11.3756 8.4375 15C8.4375 18.6244 11.3756 21.5625 15 21.5625Z"
        stroke="CurrentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.0312 9.375C22.8079 9.375 23.4375 8.7454 23.4375 7.96875C23.4375 7.1921 22.8079 6.5625 22.0312 6.5625C21.2546 6.5625 20.625 7.1921 20.625 7.96875C20.625 8.7454 21.2546 9.375 22.0312 9.375Z"
        fill="#343330"
      />
      <path
        d="M14.0625 13.125L12.1875 15"
        stroke="#343330"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.0625 17.8125L17.8125 14.0625"
        stroke="#343330"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Laundromat;
